import { render } from "./ImagensSC.vue?vue&type=template&id=55733e7a&scoped=true"
import script from "./ImagensSC.vue?vue&type=script&lang=js"
export * from "./ImagensSC.vue?vue&type=script&lang=js"

import "./ImagensSC.vue?vue&type=style&index=0&id=55733e7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55733e7a"]])

export default __exports__